import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/tom-lamb.svg';
import { UserContext } from '../hooks/UserContext';
import useAuth from '../hooks/useAuth';

const Header = () => {
  const { user, isLoading } = useContext(UserContext);
  const { logoutUser } = useAuth();

  return (
    <>
      <header className="header">
        <div className="header__container">
          <div className="header__details">
            <img className="header__img" src={logo} alt="Tom Lamb logo lettering" />
            <h3 className="header__title">Ubiquiti Checklist App</h3>
          </div>
          <nav className="header__nav">
            <Link className="header__link" to="/">Home</Link>
            {!isLoading && user && (
              <>
                <Link className="header__link" to="/checklists">Checklists</Link>
                <button className="header__btn" type="button" onClick={logoutUser}>Logout</button>
              </>
            )}
            {user === null && (
              <>
                <Link className="header__btn" to="/login">Login</Link>
                <Link className="header__btn" to="/signup">Signup</Link>
              </>
            )}
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
